export default function NewPortSection() {
  return (
    <section className="relative py-24 bg-slate-50">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        {/* Header */}
        <div className="max-w-3xl mb-12">
          <div className="inline-flex items-center space-x-2 px-4 py-2 bg-white rounded-md border border-slate-200 mb-6">
            <i className="ri-ship-line text-slate-600 text-sm"></i>
            <span className="text-slate-600 text-sm font-medium tracking-wide">增量因素</span>
          </div>

          <h2 className="text-4xl lg:text-5xl font-black text-slate-900 leading-tight mb-6">
            港口升級與外溢人流
            <span className="block mt-2 text-slate-600">新碼頭 + 翔安機場</span>
          </h2>
        </div>

        {/* 子段 1：新碼頭與港區擴建效益 */}
        <div className="mb-16">
          <h3 className="text-3xl font-black text-slate-900 mb-8">新碼頭與港區擴建效益</h3>
          
          <div className="grid md:grid-cols-3 gap-6">
            <div className="bg-white rounded-lg p-8 border-2 border-green-200 shadow-lg">
              <div className="w-12 h-12 flex items-center justify-center bg-green-500 rounded-md mb-4">
                <i className="ri-ship-line text-white text-2xl"></i>
              </div>
              <div className="text-green-700 font-bold text-sm mb-2">船班趟數提升</div>
              <div className="text-4xl font-black text-slate-900 mb-2 kpi-range">+200%</div>
              <p className="text-slate-600 text-sm">新碼頭啟用後，船班密度大幅提升，承載能力顯著增強</p>
            </div>

            <div className="bg-white rounded-lg p-8 border-2 border-blue-200 shadow-lg">
              <div className="w-12 h-12 flex items-center justify-center bg-blue-500 rounded-md mb-4">
                <i className="ri-group-line text-white text-2xl"></i>
              </div>
              <div className="text-blue-700 font-bold text-sm mb-2">人流量提升</div>
              <div className="text-4xl font-black text-slate-900 mb-2 kpi-range">+150%</div>
              <p className="text-slate-600 text-sm">年度人流量承載能力提升，為餐飲市場帶來更大基數</p>
            </div>

            <div className="bg-white rounded-lg p-8 border-2 border-orange-200 shadow-lg">
              <div className="w-12 h-12 flex items-center justify-center bg-orange-500 rounded-md mb-4">
                <i className="ri-time-line text-white text-2xl"></i>
              </div>
              <div className="text-orange-700 font-bold text-sm mb-2">通關時間縮短</div>
              <div className="text-4xl font-black text-slate-900 mb-2 kpi-range">-40%</div>
              <p className="text-slate-600 text-sm">動線優化與設施升級，提升旅客體驗與流動效率</p>
            </div>
          </div>

          <div className="mt-8 bg-gradient-to-br from-green-50 to-blue-50 rounded-lg p-8 border border-green-200">
            <div className="flex items-start space-x-4">
              <div className="w-10 h-10 flex items-center justify-center bg-green-500 rounded-md flex-shrink-0">
                <i className="ri-information-line text-white text-xl"></i>
              </div>
              <div>
                <h4 className="text-lg font-bold text-slate-900 mb-2">新碼頭＝人流入口擴張</h4>
                <p className="text-slate-600 text-sm leading-relaxed">
                  新碼頭不僅是基礎設施升級，更是金門人流入口的結構性擴張。透過船班密度提升與通關效率優化，將為金門帶來更穩定、更大規模的旅客基數，直接支撐餐飲市場的全年營運穩定性。
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* 子段 2：廈門翔安國際機場完工 */}
        <div className="mb-12">
          <h3 className="text-3xl font-black text-slate-900 mb-8">廈門翔安國際機場完工（補充分析）</h3>
          
          <div className="grid lg:grid-cols-2 gap-12">
            {/* Left: Key Points */}
            <div className="space-y-6">
              {/* Point 1 */}
              <div className="bg-white rounded-lg p-8 border border-slate-200 shadow-md">
                <div className="flex items-start space-x-4">
                  <div className="w-12 h-12 flex items-center justify-center bg-slate-900 text-white rounded-md flex-shrink-0">
                    <span className="text-xl font-black">1</span>
                  </div>
                  <div>
                    <h4 className="text-lg font-bold text-slate-900 mb-3">區域級航空樞紐定位</h4>
                    <p className="text-slate-600 text-sm leading-relaxed">
                      廈門翔安國際機場定位為區域級航空樞紐，完工後將顯著提升廈門整體航空容量，並產生跨區域移動需求。
                    </p>
                  </div>
                </div>
              </div>

              {/* Point 2 */}
              <div className="bg-white rounded-lg p-8 border border-slate-200 shadow-md">
                <div className="flex items-start space-x-4">
                  <div className="w-12 h-12 flex items-center justify-center bg-slate-900 text-white rounded-md flex-shrink-0">
                    <span className="text-xl font-black">2</span>
                  </div>
                  <div>
                    <h4 className="text-lg font-bold text-slate-900 mb-3">金門作為短停留節點</h4>
                    <p className="text-slate-600 text-sm leading-relaxed">
                      金門透過高密度小三通航線，可作為翔安機場的近距離短停留節點，承接國際轉機、商務往返與航空轉海運的混合型旅客。
                    </p>
                  </div>
                </div>
              </div>

              {/* Point 3 */}
              <div className="bg-white rounded-lg p-8 border border-slate-200 shadow-md">
                <div className="flex items-start space-x-4">
                  <div className="w-12 h-12 flex items-center justify-center bg-slate-900 text-white rounded-md flex-shrink-0">
                    <span className="text-xl font-black">3</span>
                  </div>
                  <div>
                    <h4 className="text-lg font-bold text-slate-900 mb-3">旅客特性與市場相容</h4>
                    <p className="text-slate-600 text-sm leading-relaxed">
                      該類旅客具備停留時間短、外食頻率高、品牌辨識度強之特性，與金門現有餐飲市場結構高度相容。
                    </p>
                  </div>
                </div>
              </div>
            </div>

            {/* Right: Image */}
            <div className="relative">
              <div className="sticky top-32">
                <div className="relative rounded-lg overflow-hidden shadow-lg">
                  <img
                    src="https://static.readdy.ai/image/be9b505cd22e5f355904d0d26c33bc27/0dd3aba7a76749f5e869d778dd3c6712.jpeg"
                    alt="廈門翔安國際機場"
                    className="w-full h-80 object-cover object-center"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent"></div>
                  <div className="absolute bottom-0 left-0 right-0 p-6">
                    <div className="text-white text-sm font-medium mb-1">福建省最大全新 翔安機場</div>
                    <div className="text-white/80 text-xs">鄰近金門成為最大國際中轉機場</div>
                  </div>
                </div>

                {/* Caption */}
                <div className="mt-4 bg-white rounded-lg p-4 border border-slate-200 shadow-md">
                  <div className="flex items-center space-x-2 text-slate-600 text-sm">
                    <i className="ri-information-line"></i>
                    <span>廈門翔安國際機場｜區域級航空樞紐</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
